import { Link, useNavigate } from "react-router-dom";
import { authService } from "@/core/auth/services/authService";
import { navigationState } from "@/core/routing/navigationPolicy";
import { Button } from "@/shared/components/shadcn/Button";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader } from "@/shared/components/ui/PageHeader";
import { Section } from "@/shared/components/ui/Section";

const outcomes = {
  success: "Thanks! Stripe is confirming your payment. Your new plan appears in Froppio as soon as it is confirmed.",
  cancel: "Checkout was canceled. You were not charged and your plan has not changed.",
  portal: "You returned from Stripe. Any changes to your plan appear in Froppio as soon as Stripe confirms them.",
} as const;

const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function parseSubscriptionReturn(href: string) {
  const params = new URL(href).searchParams;
  const outcome = params.get("outcome");
  const businessId = params.get("business_id");
  if (!outcome || !Object.hasOwn(outcomes, outcome) || !businessId || !uuid.test(businessId)) return null;
  return { outcome: outcome as keyof typeof outcomes, businessId };
}

export function SubscriptionReturnPage() {
  const navigate = useNavigate();
  const result = parseSubscriptionReturn(window.location.href);
  return <Page><PageHeader title="Return from Stripe" /><PageContent>
    <Section title="Check your plan" card>
      {!result ? <ErrorState message="This plan return link is invalid. Reopen Froppio and check your plan under More." /> : <>
        <p role="status">{outcomes[result.outcome]}</p>
        {authService.kind === "host" ? (
          <Button onClick={() => navigate("/", { state: navigationState("start") })}>Return to Froppio</Button>
        ) : <>
          <p className="text-sm text-muted-foreground">Using the Froppio app? Return to the app to see your updated plan.</p>
          <Button asChild>
            <Link to={`/b/${result.businessId}/plan`} state={navigationState("start")}>See your plan in Froppio</Link>
          </Button>
        </>}
      </>}
    </Section>
  </PageContent></Page>;
}
